import { ErrorMessage } from 'formik';
import busquedaTypes from '../actions/busquedas.actions';

const reducer = (state = initialEntries, action) => {

    switch (action.type) {
        case busquedaTypes.ADD_PACKAGE:

            let packages = state.paquetes;
            const index = packages.findIndex((paquete) => paquete === action.payload.paquete);

            if (index == -1) {
                return {
                    ...state,
                    tipoBusqueda: action.payload.tipoBusqueda,
                    paquetes: [...state.paquetes, action.payload.paquete]
                };

            }

        case busquedaTypes.REMOVE_PACKAGE:
            return {
                ...state,
                paquetes: state.paquetes.filter((paquete) => paquete !== action.payload.paquete)
            }

        case busquedaTypes.GET_DINARDAP_IDENTIFICACION:
        case busquedaTypes.GET_DINARDAP_APELLIDOS_NOMBRES:
        case busquedaTypes.GET_DINARDAP_PLACA_MOTOR_CHASIS:
        case busquedaTypes.GET_DINARDAP_RUC:
        case busquedaTypes.GET_DINARDAP_RAZON_SOCIAL:
        case busquedaTypes.GET_DINARDAP_IDENTIFICACION_NACIONALIDAD:
        case busquedaTypes.GET_DINARDAP_IDENTIFICACION_ANIO:
        case busquedaTypes.GET_DINARDAP_DOCIMPORTADOR_NUMAUTORIZACION:
            return {
                ...state,
                loading: true
            }

        case busquedaTypes.STORE_RESULTS:
            return {
                ...state,
                resultados: [...state.resultados, ...action.payload],
                loading: false
            }

        case busquedaTypes.STORE_VARIABLES:
            let vars = {};

            action.payload.map((variable) => {

                if (!vars.hasOwnProperty(variable.codPaquete)) {
                    vars[variable.codPaquete] = [];
                }

                vars[variable.codPaquete].push({
                    paquete: variable.codPaquete,
                    campo: variable.campoFuente,
                    etiqueta: variable.campoJabes,
                    esImagen: variable.esImagen
                })
            });

            return {
                ...state,
                variables: vars
            }

        case busquedaTypes.REMOVE_PACKAGE_RESULTS:
            return {
                ...state,
                paquetes: [],
                resultados: []
            }

        case busquedaTypes.REMOVE_RESULTS:
            return {
                ...state,
                resultados: []
            }
            
        case busquedaTypes.ERROR_RESULT:
            return {
                ...state,
                loading: false
            }

        default:
            return state;
    }
};

export default reducer;

var initialEntries = {
    tipoBusqueda: null,
    paquetes: [],
    resultados: [],
    variables: [],
    loading: false
};